/* istanbul ignore file */
import { CommaListField, TextField } from 'framework/ui/field';
import { FieldGroup } from 'framework/ui/layout';
import { ActivityType } from 'domain/shared/timeline';

const ActivityFields = (props: { [p: string]: any }) => {
  return (
    <>
      <FieldGroup
        isVisible={data =>
          ActivityType[data.getValueBySource('activityType') as keyof typeof ActivityType] === ActivityType.EMAIL
        }
      >
        <TextField source="senderEmail" label="From" />
        <CommaListField source="receiversEmails" label="To" />
        <CommaListField source="ccEmails" label="CC" />
        <CommaListField source="bccEmails" label="BCC" />
      </FieldGroup>

      <FieldGroup
        isVisible={data =>
          ActivityType[data.getValueBySource('activityType') as keyof typeof ActivityType] === ActivityType.MEETING
        }
      >
        <TextField source="location" />
      </FieldGroup>

      <FieldGroup
        isVisible={data =>
          ActivityType[data.getValueBySource('activityType') as keyof typeof ActivityType] === ActivityType.CALL
        }
      >
        <TextField source="communicationChannel" />
      </FieldGroup>
    </>
  );
};

export default ActivityFields;
